import React from 'react';
import styled from 'styled-components';
import { useModalStore } from '../../../shared/store/portal/modalStore';
import belowIcon from '../../../asset/icon/below.png';
import { GuideModalPane } from '../GuideModalContent';

/** 모바일 시트 퇴장(0.5s)과 맞춘 닫힘 대기 */
export const GUIDE_MODAL_MOBILE_CLOSE_MS = 500;

/** 현재 경로에 해당하는 가이드만 보여주는 모바일 모달. */
const GuideModalMobile: React.FC = () => {
  const { clearModal } = useModalStore();

  return (
    <Root>
      <GuideModalPane
        onClose={() => clearModal(GUIDE_MODAL_MOBILE_CLOSE_MS)}
        closeIcon={belowIcon}
        isMobile
      />
    </Root>
  );
};

const Root = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 82vh;
  min-height: 0;
  overflow: hidden;
`;

export default GuideModalMobile;
